import WOW from "wow.js"

window.WOW = WOW
new WOW({}).init()
